import {
    getSubscription,
    listSubscriptions
} from './queries';
import {
    createSubscription,
    deleteSubscription,
    updateSubscription,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {Subscription} from "../types.ts";
import {
    notifyError,
    notifySuccess
} from "../../../components/PlatformNotification";
import {generateClient} from "aws-amplify/api";
import {ListRecordsQuery} from "../../../types";


export type ListSubscriptions = {
    listSubscriptions: { items: Subscription[], nextToken: string }
}

export type GetSubscription = {
    getSubscription: Subscription
}

export type CreateSubscription = {
    createSubscription: Subscription
}

export type UpdateSubscription = {
    updateSubscription: Subscription
}

export type DeleteSubscription = {
    deleteSubscription: string
}


const client = generateClient();


export const fetchRecords = async (query: ListRecordsQuery) => {
    try {
        const response = await client.graphql<GraphQLQuery<ListSubscriptions>>({
                                                                                   query: listSubscriptions,
                                                                                   variables: {
                                                                                       ...query
                                                                                   },
                                                                               });
        return {
            items: response.data?.listSubscriptions.items,
            nextToken: response.data?.listSubscriptions.nextToken,
        };
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const fetch = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<GetSubscription>>({
                                                                                 query: getSubscription,
                                                                                 variables: {id: id},
                                                                             });
        return response.data?.getSubscription;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const add = async (payload: object) => {

    try {
        const response = await client.graphql<GraphQLQuery<CreateSubscription>>({
                                                                                    query: createSubscription,
                                                                                    variables: {input: payload},
                                                                                });
        console.debug('in the service response', response);
        notifySuccess('Subscription added');
        return response.data?.createSubscription;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const update = async (id: string, record: Subscription) => {

    console.debug('IN UPDATE', id, record);

    delete record.created;
    delete record.updated;

    try {
        const response = await client.graphql<GraphQLQuery<UpdateSubscription>>({
                                                                                    query: (updateSubscription),
                                                                                    variables: {input: record},
                                                                                });
        notifySuccess('Subscription updated');
        return response.data?.updateSubscription;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const deleteRecord = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<DeleteSubscription>>({
                                                                                    query: (deleteSubscription),
                                                                                    variables: {input: {id: id}},

                                                                                });
        notifySuccess('Subscription deleted');
        return response.data?.deleteSubscription;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};
